/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [dropzone-uploader.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 27.02.20, 14:09
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import Dropzone from "react-dropzone";
import Sortable from 'sortablejs';
import {asyncValidateAuth, notifyGalleryChange, notifyUploadChange, SUCCESS_STATUS} from "../../actions";
import {asyncAddSpaceMedia} from "../../actions/spaces";
import {ConfigurationContext} from "../configuration/configuration";
import {Cancel, ImageSearch} from "@material-ui/icons";
import {notify} from "../notifications/notify";
import {uploadFilesAsyncWorker} from "./file-uploader";
import {getMediaUploadPath} from "../../actions/environment";


class DropzoneUploader extends Component {
    state = {files: []};

    componentDidMount() {
        this.props.onRef && this.props.onRef(this);
    }

    componentWillUnmount() {
        this.state.files.forEach(file => window.URL.revokeObjectURL(file.preview));
    }

    /* @Public - the upload action must be triggered from the outside */
    onUpload = async (event) => {
        const {Lang, append = false, source='COVER'} = this.props;

        event.preventDefault();
        const {files} = this.state;

        if (files.length === 0) {
            console.log('NO FILES SELECTED');
            return;
        }

        const {username, spacepath = 'home'} = this.props;
        const ordered = [];

        /* reorder images if necessary */
        const children = document.getElementById(`upload-modal-preview-${spacepath}`).children;
        [...children].forEach(child => {
            child.dataset.position && ordered.push(files[child.dataset.position]);
        });

        const mediaUploadUrl = getMediaUploadPath(username, spacepath);
        const spaceMedia= await uploadFilesAsyncWorker(mediaUploadUrl, files);
        // const spaceMedia= await uploadFilesAsyncWorker(username, spacepath, files);

        // and create entries in the database
        this.props.asyncAddSpaceMedia(username, spacepath, {media: spaceMedia, append: append}, space => {
            notify(Lang.dialog.uploadCover.success(space.name));

            // these might be optimized to just one call..
            this.props.notifyUploadChange('UPLOAD', SUCCESS_STATUS, null);
            if(source === 'GALLERY') {
                this.props.notifyGalleryChange('UPDATE', space.id, space);
            }
        });

    };

    onDrop = (accepted) => {
        const {files, username} = this.props;
        const media = Object.assign([], files);

        /* create preview */
        accepted.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file)
        })).forEach(file => media.push(file));

        this.props.asyncValidateAuth(username);
        this.setState({files: media});
    };

    removeFile = (file) => {
        const files = this.state.files.filter(entry => entry.name !== file.name);
        window.URL.revokeObjectURL(file.preview);
        this.setState({files: files});
    };

    renderPreview = (username) => {
        const {files} = this.state;
        files.length > 0 && this.props.asyncValidateAuth(username);

        return files.map((file, idx) => {
            return <div key={file.name} className='media-upload-item' data-position={idx}>
                <img src={`${file.preview}`}/>
                <span className='media-upload-icon'
                      onClick={() => this.removeFile(file)}>
                        <Cancel fontSize='small'/>
                    </span>
            </div>;
        });
    };

    render() {

        const {className, username, spacepath, Lang} = this.props;

        return <div className={`media-rich-editor ${className ? className : ''}`}>
            <div id={`upload-modal-preview-${spacepath}`} className="media-upload-preview" ref={elem => {
                elem && Sortable.create(elem, {animation: 150});
            }}>
                {this.renderPreview(username)}
            </div>

            <Dropzone className='media-upload-zone'
                      accept="image/jpeg, image/png, image/gif, image/svg+xml"
                      onDrop={this.onDrop}>
                <div className='centered-box flex-column w-100 mt-2 mb-4'>
                    <div className='text-center media-upload-text mb-3'>{Lang.post.editor.uploadImagePlaceholder}</div>
                    <span><ImageSearch fontSize='large' style={{transform: 'scale(2.0)'}}/></span>
                </div>
            </Dropzone>
        </div>
    }
}

const withConfigurationContext = (props) => {
    return <ConfigurationContext.Consumer>
        {(values) => (<DropzoneUploader {...props} {...values}/>)}
    </ConfigurationContext.Consumer>
};

export default connect(null, {
    asyncValidateAuth,
    asyncAddSpaceMedia,
    notifyGalleryChange,
    notifyUploadChange})(withConfigurationContext);